import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate } from '../../../../utils/util';
import { Input, SelectPrintType, SelectResource } from '../../../../components/UI/ComponentsUI';
import { ENUMS, VISIONS } from '../../../../utils/constants';
import { getVision } from '../../../../services/auth';

const DropMaterialPartNumber = (props) => {
    const onChange = (event) => {
        props.onChange(event);
    };

    return (
        <div>
            <div className="input-field no-padding  col s12">
                <SelectPrintType
                    required
                    onChange={onChange}
                    value={props.filter?.print || ""}
                />
            </div>
            <div className="input-field no-padding  col s12">
                <SelectResource
                    loadConfigLaser={getVision() === VISIONS.Jeep}
                    name="resource"
                    id="resource"
                    required={props.filter.print === ENUMS.ePrintTypes.Logistics.value || props.filter.print === ENUMS.ePrintTypes.Click.value}
                    value={props.filter?.resource}
                    onChange={onChange} />
            </div>
            <div className="input-field no-padding col s12">
                <Input
                    required
                    label={translate('stock:area')}
                    id="area"
                    name="area"
                    type="text"
                    onChange={onChange}
                    defaultValue={props.filter?.area}
                />
            </div>
            <div className="input-field no-padding col s12" >
                <Input
                    required
                    label={translate('stock:partnumber')}
                    id="partNumber"
                    name="partNumber"
                    type="text"
                    onChange={onChange}
                    defaultValue={props.filter?.partNumber}
                />
            </div>
            <div className="input-field no-padding col s12" >
                <Input
                    label={translate('stock:quantity')}
                    id="quantity"
                    name="quantity"
                    type="text"
                    onChange={onChange}
                    defaultValue={props.filter?.quantity}
                />
            </div>
            {!props.pabReplanning &&
                <div className="input-field no-padding col s12" >
                    <Input
                        label={translate('stock:justification')}
                        id="justification"
                        name="justification"
                        type="text"
                        onChange={onChange}
                        defaultValue={props.filter?.justification}
                    />
                </div>
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        resources: state.logisticsResourceReducer.list,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DropMaterialPartNumber));